import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { isNullOrEmpty, showMessageToastCustom, translate } from '../../../../utils/util';
import ContainerService from '../../../../services/ContainerService';
import { Breadcrumbs, Input, Button, Table, Card, Modal } from '../../../../components/UI/ComponentsUI'
import { onValueChange, validateInputsRequired } from '../../../../utils/handleChangeHooks';
import SelectQueuePosition from '../../../../components/UI/SelectQueuePosition';
import useStateWithPromise from '../../../../utils/useEffectUpdate';
import StorageContainerRequired from './StorageContainerRequired';

const StorageContainer = (props) => {
    const dataParams = props.history?.location?.state?.dataParams;
    const [currentPage, setCurrentPage] = useState({ pageSize: 10, pageIndex: 0, sortField: "", sortOrder: 0 });
    const [container, setContainer] = useState({});
    const [openModal, setOpenModal] = useState(false);
    const [containers, setContainers] = useState([]);
    const [filter, setFilter] = useStateWithPromise({
        name: dataParams?.name.toString() || "",
        lotNumber: ""
    });

    useEffect(() => {
        onSearch(false);
        // eslint-disable-next-line
    }, [currentPage]);

    useEffect(() => {
        if (dataParams?.name) {
            searchContainer();
        }
    }, []);

    useEffect(() => {
        if (!isNullOrEmpty(filter?.lotNumber) && (props.containers?.items || []).length === 1) {
            setContainer(props.containers?.items[0]);
        } else {
            setContainer({});
            setContainers(props.containers?.items || []);
        }// eslint-disable-next-line
    }, [props?.containers?.items]);

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const searchContainer = () => {
        if (validateInputsRequired('getChange')) {
            props.getContainer(filter, (response) => {
                if (response) {
                    setContainer(response);
                } else {
                    setContainer({})
                    showMessageToastCustom(translate('warning', 'general'), "Container não encontrado", 3000, 'mdi mdi-alert-circle-outline red-text');
                }
            })
        }
    }

    const onSearch = (click) => {
        props.getPagedList({
            ...filter,
            status: [3, 4, 5, 6, 7, 8], //“Todos os estados dentro da Planta” 
            sortField: currentPage.sortField,
            sortOrder: currentPage.sortOrder,
            PageSize: click ? 50 : currentPage.pageSize,
            PageIndex: click ? 0 : currentPage.pageIndex
        });
    }

    const sendLocation = () => {
        if (validateInputsRequired("PositionsForm")) {
            if (isNullOrEmpty(container.type) || isNullOrEmpty(container.size)) {
                setOpenModal(true);
            } else {
                allocationContainer();
            }
        }
    };

    const allocationContainer = () => {
        filter.containerId = container.id;
        props.allocationContainer(filter, () => {
            showMessageToastCustom(translate('success', 'general'), `Container Alocado com sucesso`, 3000, 'mdi mdi-checkbox-marked-circle-outline green-text');
            setContainer({});
            setFilter({}).then(() => {
                onSearch(false);
            });

            if (!isNullOrEmpty(dataParams?.name)) {
                props.history.go(-1);
            }
        })
    }

    const configColumn = () => {
        const cols = [
            {
                field: 'name',
                header: 'Nome Container',
                align: 'left',
                sortable: true
            },
            {
                field: 'containerSizeName',
                header: 'Tamanho',
                align: 'left',
            },
            {
                field: 'statusDescription',
                header: 'Status Container',
                align: 'center',
                sortable: true
            },
            {
                field: 'location',
                header: 'Posição',
                align: 'center',
                sortable: true
            },
        ];
        return cols;
    };

    return (
        <div>
            <Breadcrumbs
                title={{ icon: "mdi mdi-view-dashboard-outline", label: translate('container:storage:menu.storage-container') }} />
            <div className="container-fluid" style={{ marginTop: '30px' }}>
                <div className="container" style={{ marginTop: '0px', }}>
                    <Card>
                        <div id="getChange" className="col s12">
                            <div className="row" style={{ padding: '10px' }}>
                                <div className="input-field no-padding col s5">
                                    <Input
                                        id="name"
                                        name='name'
                                        maxLength="11"
                                        label="Num. Container / MVM ou Viagem"
                                        required={isNullOrEmpty(filter?.mvmNumber) && isNullOrEmpty(filter?.lotNumber)}
                                        type="text"
                                        value={filter?.name || ''}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="input-field no-padding col s6">
                                    <Input
                                        id="lotNumber"
                                        name='lotNumber'
                                        maxLength="11"
                                        label="Num. Lote"
                                        required={isNullOrEmpty(filter?.name)}
                                        type="text"
                                        value={filter?.lotNumber || ''}
                                        onChange={onChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row" style={{ paddingTop: '5px' }}>
                            <Button full="true"
                                text="Buscar"
                                onClick={() => {
                                    if (!isNullOrEmpty(filter?.lotNumber)) {
                                        onSearch(true);
                                    }
                                    searchContainer
                                }} />
                        </div>
                        {
                            container?.id > 0 &&
                            <Table
                                totalPages={0}
                                disablePaged={true}
                                col={[
                                    {
                                        field: 'name',
                                        header: 'Container',
                                        align: 'left',
                                    },
                                    {
                                        field: 'containerSizeName',
                                        header: 'Tamanho',
                                        align: 'left',
                                    },
                                    {
                                        field: 'location',
                                        header: 'Alocação',
                                        align: 'left',
                                    },
                                    {
                                        field: 'statusDescription',
                                        header: 'Status',
                                        align: 'left',
                                    }
                                ]}
                                data={[container]}
                            />
                        }
                        {
                            container?.id > 0 &&
                            <div id="PositionsForm">
                                <SelectQueuePosition
                                    required
                                    containerSize={container.containerSizeId}
                                    onChange={onChange}
                                    queueValue={filter?.queue}
                                    columnValue={filter?.column}
                                />
                                <div className="row" style={{ paddingTop: '5px' }}>
                                    <Button full="true"
                                        text="Armazenar"
                                        onClick={sendLocation} />
                                </div>
                            </div>
                        }
                    </Card>
                </div>
                {
                    !container.id && <div id="items" className="container-fluid">
                        <Table
                            totalPages={props.list?.totalPages}
                            current={{ currentPage, setCurrentPage }}
                            col={configColumn()}
                            data={containers}
                            onClickRow={(evt) => {
                                filter.name = evt.name
                                setFilter({ ...filter }).then(() => {
                                    searchContainer();
                                })
                            }}
                        />
                    </div>
                }
            </div>
            <Modal
                open={openModal}
                disableAction={true}
                maxHeight="90%"
                id="modalContainerArmz"
                dismissible={false}
                closeModal={() => {
                    setOpenModal(false);
                }}
                children={
                    <StorageContainerRequired
                        container={container}
                        confirmUpdate={
                            () => {
                                setOpenModal(false);
                                allocationContainer();
                            }} />
                }
            />
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        usersFromElog: state.usersElogReducer.usersElog,
        user: state.userReducer.user,
        containers: state.containerReducer.containers,
        containerStatus: state.containerReducer.containerStatus,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        allocationContainer: (data, callback) => {
            dispatch(ContainerService.allocationContainer(data, callback));
        },
        getContainer: (filter, callback) => {
            dispatch(ContainerService.getContainer(filter, callback));
        },
        getStatusContainer: (filter) => {
            dispatch(ContainerService.getStatusContainer(filter));
        },
        getPagedList: (filter) => {
            dispatch(ContainerService.getContainerPaged(filter));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(StorageContainer));